export const DEFAULT_FORM_NAME = 'FORGOT_USERNAME';
export const DYNAMIC_FORGOT_USERNAME = 'dynamic-forgot-username';
